export { ErrorMessage, HelperMessage, Label, RequiredAsterisk } from '@atlaskit/form';
import Button from '@atlaskit/button';
import TextArea from '@atlaskit/textarea';
import Textfield from '@atlaskit/textfield';
import React, { ComponentProps, FunctionComponent, ReactNode } from 'react';
import styled from 'styled-components';

export const SeamlessTextfield = styled(Textfield)`
  margin-left: 8px;
  &&:not(:hover) {
    background-color: transparent;
  }

  &&:not(:focus-within) {
    border-color: transparent;
  }
`;

export const SeamlessTextArea = styled(TextArea)`
  &&:not(:hover) {
    background-color: transparent;
  }

  &&:not(:focus-within) {
    border-color: transparent;
  }
`;

const TextfieldWithIconWrapper = styled.div`
  position: relative;

  > :first-child {
    position: absolute;
    top: 50%;
    left: 10px;
    transform: translateY(-50%);
    pointer-events: none;
    z-index: 1;
    width: 24px;

    &,
    span {
      display: inline-flex;
      align-items: center;
    }
  }

  && input {
    padding-left: 32px;
  }
`;

export interface TextfieldWithIconProps
  extends Omit<ComponentProps<typeof Textfield>, 'as'> {
  isSeamless?: boolean;
  icon: ReactNode;
}

export const TextfieldWithIcon: FunctionComponent<TextfieldWithIconProps> = ({
  isSeamless,
  icon,
  ...props
}) => {
  const Component = isSeamless ? SeamlessTextfield : Textfield;

  return (
    <TextfieldWithIconWrapper>
      <span>{icon}</span>
      <Component {...props} />
    </TextfieldWithIconWrapper>
  );
};

/**
 * Renders a button with 100% width and particular spacing that is more aligned with forms. Pass an icon
 * with size="small" as iconBefore. The spacing will make sure that the icon is aligned with checkboxes
 * and other form elements.
 */
export const FormButton = styled(Button).attrs({
  shouldFitContainer: true,
  appearance: 'subtle',
  spacing: 'compact',
})`
  && {
    height: 40px;
    text-align: left;
    align-items: center;
    font-weight: normal;
    color: inherit !important;
    padding: 0 2px;
  }
`;

export const ToggleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
`;
